import React, { useEffect, useState } from "react";
import { Button, ButtonGroup } from "reactstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { constants } from "../utils";
import _ from "lodash";
import { CgDetailsMore } from "react-icons/cg";
import { MdPages } from "react-icons/md";

const PAGE_SIZES = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
]

export default function Pager(props) {
  const [disableNext, setDisableNext] = useState(true);
  const [disablePrevious, setDisablePrevious] = useState(true);
  const [showMore, setShowMore] = useState(props.pageSize === constants.UNBOUNDED_RESULT_ROW_COUNT.value ? true : false);
  const showPager = props.totalPages > 1;
  const sizeOptions = props.allowAll ? _.concat(PAGE_SIZES, [constants.UNBOUNDED_RESULT_ROW_COUNT]) : PAGE_SIZES;

  useEffect(() => {
    setDisablePrevious(props.pageNumber === 1);
    setDisableNext(props.pageNumber === props.totalPages || props.totalPages === 1);
  }, [props.pageNumber, props.totalPages, props.pageSize]);

  if (!props.callBack) {
    console.warn("Add a callBack function property on the pager that accepts a page param");
  }

  function toggleShowAllResults() {
    let showAllNow = !showMore
    setShowMore(showAllNow);
    if (showAllNow) {
      props.sizeCallback(constants.UNBOUNDED_RESULT_ROW_COUNT?.value)
    } else {
      props.sizeCallback(props.defaultPageSize)
    }
  }

  return (
    <div className={props.className || ""}>
      {showPager && (
        <span className="d-inline">
          <ButtonGroup>
            <Button
              onClick={() => props.callBack(1)}
              disabled={disablePrevious || props.downloading}
            >
              <FontAwesomeIcon icon="fast-backward" />
            </Button>
            <Button
              onClick={() => props.callBack(props.pageNumber - 1)}
              disabled={disablePrevious || props.downloading}
            >
              <FontAwesomeIcon icon="step-backward" />
            </Button>
            <span className="px-2 pt-2 border-top border-bottom border-secondary pager-back">
              Page {props.pageNumber} of {props.totalPages}
            </span>
            <Button
              onClick={() => props.callBack(props.pageNumber + 1)}
              disabled={disableNext || props.downloading}
            >
              <FontAwesomeIcon icon="step-forward" />
            </Button>
            <Button
              onClick={() => props.callBack(props.totalPages)}
              disabled={disableNext || props.downloading}
            >
              <FontAwesomeIcon icon="fast-forward" />
            </Button>
            {props.sizeCallback && !props.allowAll && (
              <Select
                classNamePrefix="serviceThreadSelect"
                className="pager-size-select"
                options={sizeOptions}
                value={_.find(sizeOptions, (ps) => ps.value === props.pageSize)}
                onChange={(opt) => props.sizeCallback(opt.value)}
                menuPlacement="auto"
                disabled={props.downloading}
              />
            )}
            {props.allowAll && (
              <Button onClick={toggleShowAllResults}>
                {showMore ? (
                  <>
                    <MdPages className="me-2" />
                    Paginate
                  </>
                ) : (
                  <>
                    <CgDetailsMore className="me-2" />
                    Show All
                  </>
                )}
              </Button>
            )}
          </ButtonGroup>
        </span>
      )}
    </div>
  );
}
